<template>
    <div class="sty-menu">
        <ul class="u-reset sty-menu--entries">
            <li class="sty-menu--entry" v-for="(section, sectionId) in sections" :key="sectionId">
                <a class="u-reset sty-menu--anchor" :href="anchor(section.anchor)" v-text="section.sectionTitle"/>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            sections: {
                type: Object,
                required: true,
            },
        },
        methods: {
            anchor(anchor) {
                return `#${ anchor }`;
            },
        },
    };
</script>
